const translations = {
    duplicateError: 'This pesticide license already exists.',
    loadError: 'Pesticide license could not be loaded.',
    save: 'Save License',
    saveError: 'Something went wrong. Please try again.',
    title: 'Edit Pesticide License'
};

export default translations;
